/** @jsxImportSource @emotion/react */
import Layout from "components/Layout"
import { Box, Typography, Divider, Container } from "@mui/material"
import { PrivacyPolicyPageStyle } from "appearance"

const PrivacyPolicyPage = () => {
  const html = `<div class=WordSection1>
  <style>
  <!--
   /* Style Definitions */
   p.MsoTitle, li.MsoTitle, div.MsoTitle
    {margin-top:0in;
    margin-right:0in;
    margin-bottom:12.0pt;
    margin-left:0in;
    text-align:center;
    page-break-after:avoid;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    text-transform:uppercase;
    border:none;
    font-weight:bold;}
  p.MsoBodyText, li.MsoBodyText, div.MsoBodyText
    {margin-top:0in;
    margin-right:0in;
    margin-bottom:12.0pt;
    margin-left:0in;
    text-align:justify;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    border:none;}
  p.MsoBodyTextFirstIndent, li.MsoBodyTextFirstIndent, div.MsoBodyTextFirstIndent
    {margin-top:0in;
    margin-right:0in;
    margin-bottom:12.0pt;
    margin-left:0in;
    text-align:justify;
    text-indent:.5in;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    border:none;}
  span.Hyperlink0
    {mso-style-name:"Hyperlink\.0";
    color:blue;
    text-decoration:underline;}
  .MsoChpDefault
    {font-size:10.0pt;
    border:none;}
   /* Page Definitions */
   @page WordSection1
    {size:8.5in 11.0in;
    margin:1.0in 1.0in 1.0in 1.0in;}
  div.WordSection1
    {page:WordSection1;}
   /* List Definitions */
   ol
    {margin-bottom:0in;}
  ul
    {margin-bottom:0in;}
  -->
  </style>
  
  <p class=MsoTitle>WEBSITE Privacy Policy</p>
  
  <p class=MsoBodyText><a name=main><b><u>Introduction</u></b></a></p>
  
  <p class=MsoBodyTextFirstIndent>Fan Space, LLC d/b/a Tribly, a Mississippi
  limited liability company (&quot;<b><u>Compan</u>y</b>,&quot; &quot;<b><u>we</u></b>&quot;
  or &quot;<b><u>us</u></b>&quot;), respects your privacy and are committed to
  protecting it through our compliance with this website privacy policy (the
  &quot;<b><u>Policy</u></b>&quot;). This Policy describes:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>The types of information we may collect or that you may provide
  when you download, access or use the URL www.triblymusic.com or any other
  website that you may be redirected to by the Company (the &quot;<b><u>Website</u></b>&quot;).</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Our practices for collecting, using, maintaining, protecting and
  disclosing that information.</p>
  
  <p class=MsoBodyTextFirstIndent>This Policy applies to information we collect
  on this Website, in e-mail, text and other electronic communications sent
  through or in connection with this Website. </p>
  
  <p class=MsoBodyTextFirstIndent style='text-indent:0in'>This Policy DOES NOT
  apply to information that:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>We collect offline or on any other Company applications or
  websites, including other applications and websites you may access through this
  Website. </p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>You provide to or is collected by any third party.</p>
  
  <p class=MsoBodyTextFirstIndent>Our other applications and websites, and those
  of third parties, may have their own privacy policies, which we encourage you
  to read before providing information on or through them.</p>
  
  <p class=MsoBodyTextFirstIndent>Please read this Policy carefully to understand
  our policies and practices regarding your information and how we will treat it.
  If you do not agree with our policies and practices, do not download, register
  with or use this Website. By downloading, registering with or using this
  Website, you agree to this Policy and each of the terms and conditions it
  contains. This Policy may change from time to time. Your continued use of this
  Website after we make changes is deemed to be acceptance of those changes, so
  please check the Policy periodically for updates. </p>
  
  <p class=MsoBodyText><b><u>Information We Collect and How We Collect It</u></b></p>
  
  <p class=MsoBodyTextFirstIndent style='text-indent:0in'>We collect information
  from and about users of our Website, including you:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Directly from you when you provide it to us.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Automatically when you use the Website. </p>
  
  <p class=MsoBodyText><b><u>Information You Provide to Us</u></b> </p>
  
  <p class=MsoBodyTextFirstIndent>When you download, register with or use this
  Website, we may ask you provide information:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>By which you may be personally identified, such as name, postal
  address, e-mail address, telephone number, credit card or other payment
  information, or any other information the Website collects that is or may be
  defined as personal information under applicable law (&quot;<b><u>personal
  information</u></b>&quot;).</p>
  
  <p class=MsoBodyTextFirstIndent style='text-indent:0in'>This information may
  include:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Information that you provide by filling in forms in the Website,
  such as information provided at the time of registering to use the Website,
  subscribing to our service, posting material, and requesting further services.
  We may also ask you for information when you report a problem with the Website.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Records and copies of your correspondence (including e-mail
  addresses and phone numbers), if you contact us.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Your responses to surveys that we might ask you to complete for
  research purposes.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Your search queries on the Website.</p>
  
  <p class=MsoBodyTextFirstIndent>You may provide information to be published or
  displayed (&quot;<b><u>Posted</u></b>&quot;) on public areas of the Website or
  websites you access through the Website (collectively, &quot;<b><u>User
  Contributions</u></b>&quot;). Your User Contributions are Posted and
  transmitted to others at your own risk. Additionally, we cannot control the
  actions of third parties with whom you may choose to share your User
  Contributions. Therefore, we cannot and do not guarantee that your User
  Contributions will not be viewed by unauthorized persons or used
  inappropriately.</p>
  
  <p class=MsoBodyText><b><u>Automatic Information Collection And Tracking</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>When you download, access and use the Website,
  it may use technology to automatically collect:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Usage Details.</b> When you access and use the Website, we may
  automatically collect certain details of your access to and use of the Website,
  including traffic data, location data, logs, and other communication data and
  the resources that you access and use on or through the Website. </p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Device Information.</b> We may collect information about your
  mobile device and internet connection, including the device's unique device
  identifier, IP address, operating system, browser type, mobile network information
  and the device's telephone number.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Stored Information and Files.</b> The Website also may access
  metadata and other information associated with other files stored on your
  device. This may include, for example, photographs, audio and video clips, personal
  contacts and address book information.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Location Information.</b> This Website collects real-time
  information about the location of your device.</p>
  
  <p class=MsoBodyTextFirstIndent>If you do not want us to collect the above
  information do not access or use the Website. </p>
  
  <p class=MsoBodyTextFirstIndent>We also may use these technologies to collect
  information about your activities over time and across third party websites,
  applications or other online services, commonly referred to as behavioral
  tracking.</p>
  
  <p class=MsoBodyText><b><u>Information Collection And Tracking Technologies</u></b>
  </p>
  
  <p class=MsoBodyTextFirstIndent>The technologies we use for automatic
  information collection may include:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Cookies (or mobile cookies).</b> A cookie is a small file
  placed on your smartphone or electronic device. It may be possible to refuse to
  accept mobile cookies by activating the appropriate setting on your smartphone
  or electronic device. However, if you select this setting, you may be unable to
  access certain parts of our Website. </p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Web Beacons.</b> Pages of the Website and our e-mails may
  contain small electronic files known as web beacons (also referred to as clear
  gifs, pixel tags and single-pixel gifs) that permit the Company, for example,
  to count users who have visited those pages or opened an e-mail and for other
  related Website statistics (for example, recording the popularity of certain
  content and verifying system and server integrity).</p>
  
  <p class=MsoBodyText><b><u>Third-Party Information Collection</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>When you use the Website or its content,
  certain third parties may use automatic information collection technologies to
  collect information about you or your device. </p>
  
  <p class=MsoBodyTextFirstIndent>Third parties may use tracking technologies to
  collect information about you when you use this Website. The information they
  collect may be associated with your personal information, or they may use
  behavioral tracking to collect information about your online activities over
  time and across different websites, applications, and other online services.
  They may use this information to provide you with interest-based (behavioral)
  advertising or other targeted content. </p>
  
  <p class=MsoBodyTextFirstIndent>We do not control third parties' tracking
  technologies or how the information they collect may be used. If you have any
  questions about an advertisement or other targeted content, you should contact
  the responsible provider directly. </p>
  
  <p class=MsoBodyText><b><u>How We Use Your Information</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We use information that we collect about you or
  that you provide to us, including any personal information, to:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Provide you with the Website and its contents, and any other
  information, products or services that you request from us.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Fulfill any other purpose for which you provide it.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Give you notices about your account, including expiration and
  renewal notices.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Carry out our obligations and enforce our rights arising from any
  contracts entered into between you and us, including the Terms of Use for sale
  of goods and services and for billing and collection.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Notify you when Website updates are available and of changes to
  any products or services we offer or provide.</p>
  
  <p class=MsoBodyTextFirstIndent>The usage information we collect helps us to
  improve our Website and to deliver a better and more personalized experience by
  enabling us to:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Estimate our audience size and usage patterns.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Store information about your preferences, allowing us to
  customize our Website according to your individual interests.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Speed up your searches.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Recognize you when you use the Website.</p>
  
  <p class=MsoBodyText><b><u>Disclosure of Your Information</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We may disclose aggregated information about
  our users, and information that does not identify any individual or device,
  without restriction.  In addition, we may disclose personal information that we
  collect or you provide:</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To our subsidiaries and affiliates.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To contractors, service providers and other third parties we use
  to support our business and who are bound by contractual obligations to keep
  personal information confidential and use it only for the purposes for which we
  disclose it to them.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To a buyer or other successor in the event of a merger,
  divestiture, restructuring, reorganization, dissolution or other sale or
  transfer of some or all of the Company's assets, whether as a going concern or
  as part of bankruptcy, liquidation or similar proceeding, in which personal
  information held by the Company about our Website users is among the assets
  transferred.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To fulfill the purpose for which you provide it. For example, if
  you give us an e-mail address to use the &quot;e-mail a friend&quot; feature of
  our Website, we will transmit the contents of that e-mail and your e-mail
  address to the recipients.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>For any other purpose disclosed by us when you provide the
  information.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>With your consent.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To comply with any court order, law or legal process, including
  to respond to any government or regulatory request or request from a securities
  exchange.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To enforce our rights arising from any contracts entered into
  between you and us, including the Terms of Use.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>If we believe disclosure is necessary or appropriate to protect
  the rights, property, or safety of Company, our customers or others, including
  exchanging information with other companies and organizations for the purposes
  of fraud protection and credit risk reduction.</p>
  
  <p class=MsoBodyText style='page-break-after:avoid'><b><u>Your Choices about
  Our Collection, Use and Disclosure of Your Information</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We strive to provide you with choices regarding
  the handling of personal information you provide to us. This section describes
  mechanisms we provide for you to control certain uses and disclosures of your
  information. </p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Tracking Technologies.</b> You can set your browser to refuse
  all or some browser cookies or to alert you when cookies are being sent. If you
  disable or refuse cookies or block the use of other tracking technologies, some
  parts of the Website may then be inaccessible or not function properly.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Location Information.</b> You can choose whether or not to
  allow the Website to collect and use real-time information about your device's
  location through the device's privacy settings. If you block the use of
  location information, some parts of the Website may then be inaccessible or not
  function properly.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Promotion by the Company.</b> If you do not want us to use
  your e-mail address to promote our own or third parties' products or services,
  you can opt-out of such. You can also always opt out by logging into the
  Website and adjusting your user preferences in your account profile by checking
  or unchecking the relevant boxes or by sending us an e-mail or text message
  stating your opt out request to info@triblymusic.com.</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Targeted Advertising by the Company.</b> If you do not want us
  to use information that we collect or that you provide to us to deliver
  advertisements according to our advertisers' target-audience preferences, you
  can opt out of such. You can also always adjust your user advertising
  preferences in your account profile by checking or unchecking the relevant
  boxes or by sending us an e-mail stating your request to info@triblymusic.com</p>
  
  <p class=MsoBodyTextFirstIndent style='margin-left:.5in;text-indent:-.25in'><span
  style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b>Disclosure of Your Information for Third-Party Advertising and
  Marketing.</b> If you do not want us to share your personal information with
  unaffiliated or non-agent third parties for advertising and marketing purposes,
  you can opt out of such. You can also always opt out by logging into the
  Website and adjusting your user preferences in your account profile by checking
  or unchecking the relevant boxes or by sending us an e-mail stating your
  request to info@triblymusic.com.</p>
  
  <p class=MsoBodyText><b><u>Accessing and Correcting Your Personal Information</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>You can review and change your personal
  information by logging into the Website and visiting your account profile page.
  </p>
  
  <p class=MsoBodyTextFirstIndent>You may also send us an e-mail at
  info@triblymusic.com to request access to, correct or delete any personal
  information that you have provided to us. We cannot delete your personal
  information except by also deleting your user account. We may not accommodate a
  request to change information if we believe the change would violate any law or
  legal requirement or cause the information to be incorrect.</p>
  
  <p class=MsoBodyText><b><u>Data Security</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We have implemented measures designed to secure
  your personal information from accidental loss and from unauthorized access,
  use, alteration and disclosure. </p>
  
  <p class=MsoBodyTextFirstIndent>The safety and security of your information
  also depends on you. Where we have given you (or where you have chosen) a
  password for access to certain parts of our Website, you are responsible for
  keeping this password confidential. We ask you not to share your password with
  anyone. We urge you to be careful about giving out information in public areas
  of the Website like message boards. The information you share in public areas
  may be viewed by any user of the Website.</p>
  
  <p class=MsoBodyTextFirstIndent>Unfortunately, the transmission of information
  via the Internet and mobile platforms is not completely secure. Although we do
  our best to protect your personal information, we cannot and do not guarantee
  the security of your personal information transmitted through our Website. Any
  transmission of personal information is at your own risk. We are not
  responsible for circumvention of any privacy settings or security measures we
  provide.</p>
  
  <p class=MsoBodyText><b><u>Changes to Our Privacy Policy</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We may update our Policy from time to time. If
  we make material changes to how we treat our users' personal information, we
  will post the new privacy policy on this page with a notice that the Policy has
  been updated and notify you by e-mail and/or text message to the primary e-mail
  address and/or phone number specified in your account.</p>
  
  <p class=MsoBodyTextFirstIndent>The date the Policy was last revised is
  identified at the top of this page. You are responsible for ensuring we have an
  up-to-date, active and deliverable e-mail address and/or phone number for you
  and for periodically reviewing the Policy to check for any changes.</p>
  
  <p class=MsoBodyText><b><u>Contact Information</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>To ask questions or comment about this Policy
  and our privacy practices, contact us at: </p>
  
  <p class=MsoBodyText style='margin-left:1.0in'><a
  href="mailto:info@triblymusic.com"><span class=Hyperlink0><span
  style='color:white'><span style='color:white'>info@triblymusic.com</span></span></span></a><br>
  10 Canebrake Blvd. Suite 110, Flowood, MS 39232</p>
  
  </div>`

  return (
    <Layout title="Collections">
      <Box css={PrivacyPolicyPageStyle.FeaturedBoxStyle}>
        <Typography variant="h1">Privacy Policy</Typography>
      </Box>
      <Divider />

      <Container sx={{ padding: 4 }}>
        <Box dangerouslySetInnerHTML={{ __html: html }}></Box>
      </Container>
    </Layout>
  )
}

export default PrivacyPolicyPage
